/* ===========================================================================
   DRINEA — Interactions thème (porté du master drinea-site).
   - Reveal on scroll (.rv → .in)
   - Galerie produit : miniatures → image principale
   - Variant picker RÉEL : Couleur + Taille → variante Shopify → hidden name="id"
     + prix affiché + disponibilité (ATC désactivé si rupture) + état visuel.
     Fallback propre en aperçu sans produit (sélecteurs cliquables, pas de casse).
   - Sélecteur pack (UI placeholder, câblage S3 via Shopify Bundles)
   - Accordéon FAQ
   - Sticky ATC (apparaît quand le bloc d'achat sort du viewport)
   - Menu burger → scroll vers l'offre
   Aucun appel paiement. Aucune dépendance externe. Vanilla pur.
   =========================================================================== */
(function () {
  'use strict';

  /* ---- Reveal on scroll ---- */
  function initReveal() {
    var els = document.querySelectorAll('.rv');
    if (!('IntersectionObserver' in window) || !els.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- Galerie produit : miniatures → image principale ---- */
  function initGallery() {
    var main = document.querySelector('[data-gallery-main]');
    if (!main) return;
    document.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        document.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('on'); });
        thumb.classList.add('on');
        var img = thumb.querySelector('img');
        var full = thumb.getAttribute('data-full') || (img && img.src);
        if (full) main.src = full;
      });
    });
  }

  /* ---- Helpers ---- */
  function norm(v) {
    // Comparaison d'options insensible à la casse / espaces parasites.
    return (v == null ? '' : String(v)).trim().toLowerCase();
  }
  function formatMoney(cents) {
    // Money Shopify côté serveur ; ici fallback d'affichage JS (centimes → "34,90€").
    if (typeof cents !== 'number' || isNaN(cents)) return '';
    return (cents / 100).toFixed(2).replace('.', ',') + '€';
  }

  /* ---- Variant picker RÉEL ----
     Lit le JSON [data-drinea-variants] (product.variants) + l'ordre des options
     [data-drinea-option-position]. À chaque changement Couleur/Taille :
       - trouve la variante dont TOUTES les options matchent
       - met à jour le hidden name="id", le prix, la disponibilité, l'état visuel
     Sans produit (aperçu) : pas de JSON → les sélecteurs restent cliquables
     visuellement sans toucher au panier (aucune casse). */
  function initVariantPicker() {
    var form = document.getElementById('buybox-form');
    var dataEl = document.querySelector('[data-drinea-variants]');

    // --- Sélection visuelle commune (swatch couleur + image galerie + libellé) ---
    var galMain = document.querySelector('[data-gallery-main]');
    var colorNameEl = document.querySelector('[data-color-name]');
    function selectSwatch(sw) {
      document.querySelectorAll('[data-swatch]').forEach(function (s) { s.classList.remove('on'); });
      sw.classList.add('on');
      var img = sw.getAttribute('data-img');
      if (galMain && img) galMain.src = img;
      if (colorNameEl) colorNameEl.textContent = sw.getAttribute('data-color') || '';
    }
    function selectSize(btn) {
      document.querySelectorAll('[data-size-value]').forEach(function (x) { x.classList.remove('on'); });
      btn.classList.add('on');
    }

    // --- Mode APERÇU (pas de produit / pas de JSON) : visuel seul, zéro panier ---
    if (!dataEl) {
      document.querySelectorAll('[data-swatch]').forEach(function (sw) {
        sw.addEventListener('click', function () { selectSwatch(sw); });
      });
      document.querySelectorAll('[data-size-value]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.classList.contains('soldout')) return;
          selectSize(btn);
        });
      });
      return;
    }

    // --- Mode PRODUIT RÉEL ---
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent || '[]'); } catch (e) { variants = []; }
    if (!Array.isArray(variants) || !variants.length) return;

    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var atcBtn = form ? form.querySelector('button[name="add"], button[type="submit"]') : null;
    var priceEls = document.querySelectorAll('[data-price-now]');

    // Position des options : data-drinea-option-position="1|2|3" sur les conteneurs.
    function optionPos(el) {
      var holder = el.closest('[data-drinea-option-position]');
      var pos = holder ? parseInt(holder.getAttribute('data-drinea-option-position'), 10) : NaN;
      return isNaN(pos) ? null : pos; // 1-based, comme variant.options[pos-1]
    }

    // Sélection courante par position d'option → valeur normalisée.
    var selected = {};
    // Init depuis les éléments déjà marqués .on (1ère variante dispo côté serveur).
    var initSwatch = document.querySelector('[data-swatch].on');
    var initSize = document.querySelector('[data-size-value].on');
    if (initSwatch) selected[optionPos(initSwatch)] = norm(initSwatch.getAttribute('data-color'));
    if (initSize) selected[optionPos(initSize)] = norm(initSize.getAttribute('data-size-value'));

    function findVariant() {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var opts = v.options || [];
        var match = true;
        for (var pos in selected) {
          if (!Object.prototype.hasOwnProperty.call(selected, pos)) continue;
          if (norm(opts[parseInt(pos, 10) - 1]) !== selected[pos]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    function applyVariant() {
      var v = findVariant();
      if (!v) {
        // Combinaison inexistante : panier neutralisé + message clair.
        if (idInput) idInput.value = '';
        if (atcBtn) {
          atcBtn.disabled = true;
          atcBtn.setAttribute('aria-disabled', 'true');
          atcBtn.textContent = 'Combinaison indisponible';
        }
        return;
      }
      if (idInput) idInput.value = v.id;
      var priceTxt = (typeof v.price === 'number') ? formatMoney(v.price) : '';
      if (priceTxt) priceEls.forEach(function (el) { el.textContent = priceTxt; });
      if (atcBtn) {
        if (v.available) {
          atcBtn.disabled = false;
          atcBtn.removeAttribute('aria-disabled');
          var label = atcBtn.getAttribute('data-atc-label') || 'Profiter de l\'offre';
          atcBtn.innerHTML = label + (priceTxt ? ' — <span data-price-now>' + priceTxt + '</span>' : '');
          priceEls = document.querySelectorAll('[data-price-now]'); // re-collect après innerHTML
        } else {
          atcBtn.disabled = true;
          atcBtn.setAttribute('aria-disabled', 'true');
          atcBtn.textContent = 'Rupture';
        }
      }
    }

    document.querySelectorAll('[data-swatch]').forEach(function (sw) {
      sw.addEventListener('click', function () {
        selectSwatch(sw);
        var pos = optionPos(sw);
        if (pos != null) selected[pos] = norm(sw.getAttribute('data-color'));
        applyVariant();
      });
    });
    document.querySelectorAll('[data-size-value]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.classList.contains('soldout')) return;
        selectSize(btn);
        var pos = optionPos(btn);
        if (pos != null) selected[pos] = norm(btn.getAttribute('data-size-value'));
        applyVariant();
      });
    });

    // État initial cohérent dès le chargement.
    applyVariant();
  }

  /* ---- Sélecteur pack (UI placeholder — câblage S3 via Shopify Bundles) ----
     Met uniquement à jour l'ÉTAT VISUEL du pack choisi (pas de logique panier).
     Les vrais bundles Duo/Trio sont des pages produit distinctes (settings URL). */
  function initPacks() {
    document.querySelectorAll('[data-pack]').forEach(function (opt) {
      opt.addEventListener('click', function () {
        document.querySelectorAll('[data-pack]').forEach(function (x) { x.classList.remove('on'); });
        opt.classList.add('on');
      });
    });
  }

  /* ---- Accordéon FAQ ---- */
  function initFaq() {
    var items = document.querySelectorAll('.q-item');
    items.forEach(function (it) {
      var head = it.querySelector('.q-head');
      var body = it.querySelector('.q-body');
      if (!head || !body) return;
      head.addEventListener('click', function () {
        var open = it.classList.contains('open');
        items.forEach(function (x) {
          x.classList.remove('open');
          var b = x.querySelector('.q-body');
          if (b) b.style.maxHeight = null;
        });
        if (!open) {
          it.classList.add('open');
          body.style.maxHeight = body.scrollHeight + 'px';
        }
      });
    });
  }

  /* ---- Sticky ATC : visible quand le bloc d'achat / hero sort du viewport ---- */
  function initStickyAtc() {
    var satc = document.querySelector('[data-sticky-atc]');
    var anchor = document.querySelector('[data-sticky-anchor]');
    if (!satc || !anchor || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      satc.classList.toggle('show', !entries[0].isIntersecting);
    }, { threshold: 0 }).observe(anchor);
  }

  /* ---- Menu burger → ouvre/ferme le menu mobile (vraie navigation) ---- */
  function initBurger() {
    var burger = document.querySelector('.burger');
    var nav = document.querySelector('nav');
    if (!burger || !nav) return;
    burger.addEventListener('click', function () {
      var open = nav.classList.toggle('nav-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    nav.querySelectorAll('.nav-links a').forEach(function (a) {
      a.addEventListener('click', function () {
        nav.classList.remove('nav-open');
        burger.setAttribute('aria-expanded', 'false');
      });
    });
  }

  function boot() {
    initReveal();
    initGallery();
    initVariantPicker();
    initPacks();
    initFaq();
    initStickyAtc();
    initBurger();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
